import { FilePlus } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconDocumentPlus(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <FilePlus />
    </IconWrapper>
  );
}
